import { createRoute, lazyRouteComponent } from "@tanstack/react-router";

import { authenticatedRoute } from "../_authenticated.js";

export const portalUsersNewRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: "/portal-users/new",
  component: lazyRouteComponent(() => import("./portal-users.new.page.js"), "PortalUsersNewPage"),
});
